import { Box, Typography } from '@mui/material';
import { LocationOnIcon } from 'components/icons';
import React from 'react';

interface LocationComponentProps {
	parkingLocationName: string;
}

const LocationComponent: React.FC<LocationComponentProps> = (props) => {
	const { parkingLocationName } = props;
	return (
		<Box
			style={{
				display: 'flex',
				alignItems: 'center',
				gap: '0.5rem',
			}}
		>
			<LocationOnIcon color="primary" />
			<Box>
				<Typography
					variant="caption"
					color="primary"
					sx={{
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						maxWidth: '200px', // adjust as needed
						display: 'block',
					}}
				>
					{parkingLocationName}
				</Typography>
			</Box>
		</Box>
	);
};

export default LocationComponent;
